<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row class="mb-5">
        <b-col>
          <b-card class="px-3" v-if="RegulationForNextYearDetail.statusid">
            <range-slider-component
              :id="RegulationForNextYearDetail.statusid"
            ></range-slider-component>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="5">
          <b-card class="CardMain">
            <b-row>
              <b-col>
                <table>
                  <tr>
                    <td style="width:70%">{{ $t("docnumber") }}:</td>
                    <td style="width:30%">
                      <b>{{ RegulationForNextYearDetail.docnumber }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("docdate") }}:</td>
                    <td>
                      <b>{{ RegulationForNextYearDetail.docdate }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("finyear") }}:</td>
                    <td>
                      <b>{{ RegulationForNextYearDetail.finyear }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("organization") }}:</td>
                    <td>
                      <b>{{ RegulationForNextYearDetail.organizationname }}</b>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>{{ $t("department") }}:</td>
                    <td>
                      <b>{{ RegulationForNextYearDetail.departmentname }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("personname") }}:</td>
                    <td>
                      <b>{{ RegulationForNextYearDetail.personname }}</b>
                    </td>
                  </tr> -->
                  <tr>
                    <td>{{ $t("status") }}:</td>
                    <td>
                      <span
                        :class="
                          `badge rounded-pill bg-${getColorStatus(
                            RegulationForNextYearDetail
                          )} ms-1`
                        "
                      >
                        {{ RegulationForNextYearDetail.statusname }}
                      </span>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col sm="12" lg="5">
          <b-card class="TableCard">
            <table>
              <tbody>
                <tr>
                  <td style="width:40%">{{ $t("detailinfo") }}:</td>
                  <td>
                    <b>{{ RegulationForNextYearDetail.detailinfo }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
          <!-- <b-card class="TableCard">
            <b-row>
              <b-col
                v-for="(item, index) in RegulationDetailTables"
                :key="index"
              >
                <table>
                  <tr>
                    <td style="width:70%">{{ $t("purchasepurpose") }}:</td>
                    <td>
                      <b>{{ item.purchasepurpose }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("productcategory") }}:</td>
                    <td>
                      <b>{{ item.productcategoryname }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("product") }}:</td>
                    <td>
                      <b>{{ item.productname }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("productinfo") }}:</td>
                    <td>
                      <b>{{ item.productinfo }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("unitofmeasure") }}:</td>
                    <td>
                      <b>{{ item.unitofmeasurename }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("purchasequantity") }}:</td>
                    <td>
                      <b>{{ item.purchasequantity }}</b>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card> -->
        </b-col>
        <b-col class="text-right">
          <b-button
            @click="$router.go(-1)"
            variant="danger"
            class="mb-1"
            style="width:100%"
            ><i class="dripicons-arrow-thin-left"></i>
            {{ $t("back") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionForNextYearSend', 'permissions') &&
                RegulationForNextYearDetail.CanSend === true
            "
            @click="OpenSendModal"
            variant="success"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("Send") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionForNextYearAccept', 'permissions') &&
                RegulationForNextYearDetail.CanAccept === true
            "
            @click="OpenAcceptModal"
            variant="success"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("Accept") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionForNextYearApprove', 'permissions') &&
                RegulationForNextYearDetail.CanApprove === true
            "
            @click="OpenApproveModal"
            variant="success"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("Approve") }}</b-button
          >
          <b-button
            v-if="
              $can(
                'PurchaseRequisitionForNextYearCancelApproval',
                'permissions'
              ) && RegulationForNextYearDetail.CanCancelApprove === true
            "
            @click="OpenCancelApprovalModal"
            variant="danger"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("CancelApproval") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionForNextYearReject', 'permissions') &&
                RegulationForNextYearDetail.CanReject === true
            "
            @click="OpenRejectModal"
            variant="danger"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-x"></i> {{ $t("Reject") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionForNextYearEstimate', 'permissions') &&
                RegulationForNextYearDetail.CanEstimat === true
            "
            @click="OpenEstimateModal"
            variant="success"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("Estimate") }}</b-button
          >
          <b-button
            @click="OpenSideBar"
            variant="info"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-history"></i> {{ $t("history") }}</b-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="TableCard">
            <!-- <b-table
              :items="RegulationDetailTables"
              responsive
              :fields="fields"
              primary-key="id"
              sticky-header="65vh"
              striped
              no-border-collapse
              show-empty
              :empty-text="$t('NotFound')"
              class="position-relative"
            > -->
            <b-table
              :fields="fields"
              bordered
              responsive
              :busy="isLoading"
              head-row-variant="info"
              :foot-clone="true"
              no-footer-sorting
              sticky-header="60vh"
              no-border-collapse
              striped
              small
              :items="RegulationMonthsDetailTables"
              class="text-center"
            >
              <template #cell(Quater1)="{item}">
                {{
                  $options.filters.currency(item.QuantityByPeriod.Quarter1, {
                    symbol: " ",
                    fractionCount: 0,
                  })
                }}
              </template>
              <template #cell(Quater2)="{item}">
                {{
                  $options.filters.currency(item.QuantityByPeriod.Quarter2, {
                    symbol: " ",
                    fractionCount: 0,
                  })
                }}
              </template>
              <template #cell(Quater3)="{item}">
                {{
                  $options.filters.currency(item.QuantityByPeriod.Quarter3, {
                    symbol: " ",
                    fractionCount: 0,
                  })
                }}
              </template>
              <template #cell(Quater4)="{item}">
                {{
                  $options.filters.currency(item.QuantityByPeriod.Quarter4, {
                    symbol: " ",
                    fractionCount: 0,
                  })
                }}
              </template>
              <template #cell(Yearly)="{item}">
                {{
                  $options.filters.currency(item.QuantityByPeriod.Yearly, {
                    symbol: " ",
                    fractionCount: 0,
                  })
                }}
              </template>
              <template #cell(number)="{item}">
                {{ item.ordernumber }}
              </template>
              <!-- <template #foot(purchasepurpose)>
                {{ $t("Total") }}
              </template> -->
              <template #foot(Quater2)> {{ $t("") }}</template>
              <template #foot(purchasebasename)> {{ $t("") }}</template>
              <template #foot(Quater1)> {{ $t("") }}</template>
              <template #foot(Quater3)> {{ $t("") }}</template>
              <template #foot(Quater4)> {{ $t("") }}</template>
              <template #foot(yearly)> {{ $t("") }}</template>
              <template #foot(actions)> {{ $t("") }}</template>
              <template #foot(itemofexpensename)> {{ $t("") }}</template>
              <template #foot(organizationaccountname)> {{ $t("") }}</template>
              <template #foot(purchasebase)> {{ $t("") }}</template>
              <template #foot(unitofmeasurename)> {{ $t("") }}</template>
              <template #foot(productinfo)> {{ $t("") }}</template>
              <template #foot(productname)> {{ $t("") }}</template>
              <template #foot(productenktcode)> {{ $t("") }}</template>
              <template #foot(number)> {{ $t("Total") }}</template>

              <template #cell(YearlySum)="{item}">
                {{
                  $options.filters.currency(item.SumByPeriod.Yearly, {
                    symbol: " ",
                    fractionCount: 2,
                  })
                }}
              </template>
              <template #foot(YearlySum)>
                <div class="text-right">
                  {{
                    $options.filters.currency(total.totalsum, {
                      symbol: "  ",
                      fractionCount: 2,
                    })
                  }}
                </div>
              </template>
              <template #cell(actions)="{item}">
                <b-link
                  v-b-tooltip.hover.top="
                    item.organizationaccountid == null
                      ? $t('Priced')
                      : $t('Edit')
                  "
                  class="m-2"
                  v-if="
                    $can('PurchaseRequisitionEstimate', 'permissions') &&
                      RegulationForNextYearDetail.CanEstimat === true
                  "
                  @click="OpenPurReqTableModal(item)"
                >
                  <i class="bx bx-pencil"></i>
                </b-link>
                <b-link
                  @click="OpenPurReqTableModalView(item)"
                  v-b-tooltip.hover.top="$t('View')"
                >
                  <i class="mdi mdi-eye"></i>
                </b-link>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-sidebar width="500px" no-header v-model="SideBar" right shadow>
        <div class="px-3 py-2">
          <div class="row" style="height:800px;overflow-y:auto">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class>
                    <ul
                      v-for="(item, index) in RegulationDetailHistory"
                      :key="index"
                      class="verti-timeline list-unstyled"
                    >
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="bx bx-right-arrow-circle"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <i class="bx bx-copy-alt h2 text-primary"></i>
                          </div>
                          <div class="media-body">
                            <div>
                              <table>
                                <tr>
                                  <td>
                                    <h5>{{ item.organizationinfo }}</h5>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p class="text-muted">
                                      {{ item.dateofcreated }}
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p>
                                      {{ item.userinfo }} -
                                      <b> {{ item.username }} </b> - <br />
                                      <span
                                        :class="
                                          `badge rounded-pill bg-${getColor(
                                            item
                                          )} ms-1`
                                        "
                                      >
                                        {{ item.statusname }}
                                      </span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p v-if="item.statusname === 'Отклонен'">
                                      <span
                                        :class="
                                          `badge rounded-pill bg-${getColor(
                                            item
                                          )} ms-1`
                                        "
                                      >
                                        {{ $t("ReasonOfCancel") }}
                                      </span>
                                      : {{ item.adddata }}
                                    </p>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <!-- <div>
                              <h5>{{ item.organizationinfo }}</h5>
                              <p class="text-muted">
                                {{ item.dateofcreated }}
                              </p>
                              <p>
                                {{ item.userinfo }} -
                                <b> {{ item.username }} </b> - <br />
                                <span
                                  :class="
                                    `badge rounded-pill bg-${getColor(
                                      item
                                    )} ms-1`
                                  "
                                >
                                  {{ item.statusname }}
                                </span>
                              </p>
                              <p v-if="item.statusname === 'Не принято'">
                                <b-badge variant="light-danger">
                                  {{ $t("ReasonOfCancel") }}
                                </b-badge>
                                : {{ item.adddata }}
                              </p>
                            </div> -->
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #footer="{ hide }">
          <div class="d-flex text-light align-items-center px-3 py-2">
            <b-button style="width:100%" variant="danger" @click="hide"
              ><i class="dripicons-arrow-thin-left"></i
              >{{ $t("back") }}</b-button
            >
          </div>
        </template>
      </b-sidebar>
      <b-modal
        v-model="PurReqTableModal"
        no-close-on-backdrop
        hide-footer
        size="xl"
        :title="$t('Tables')"
      >
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-12" for
                    >{{ $t("purchasepurpose") }} :
                    <b>{{ tabrow.purchasepurpose }}</b></label
                  >
                  <!-- <div class="col-sm-12 mt-2">
                    <b>{{ tabrow.purchasepurpose }}</b>
                  </div> -->
                </div>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("productcategory") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.productenktcode }}</b>
                  </div>
                </div>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("product") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.productname }}</b>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-12" for
                    >{{ $t("productinfo") }} :
                    <b>{{ tabrow.productinfo }}</b></label
                  >
                  <!-- <div class="col-sm-12 mt-2">
                    <b>{{ tabrow.productinfo }}</b>
                  </div> -->
                </div>
                <!-- <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("unitofmeasure") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.unitofmeasurename }}</b>
                  </div>
                </div> -->
                <!-- <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("yearly") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.QuantityByPeriod.Yearly }}</b>
                  </div>
                </div> -->
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-0 pb-2">
              <b-col>
                <b-card
                  class="mb-0 "
                  style="border: 2px solid #94BDE7;border-radius: 10px"
                >
                  <p class="text-center mt-0 pt-0">{{ $t("UzexPrice") }}</p>
                  <b-row>
                    <b-col>{{ $t("max") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:red">{{
                        $options.filters.currency(UzexPrice.max, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("avg") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:orange">
                        {{
                          $options.filters.currency(UzexPrice.avg, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>{{ $t("min") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:green">
                        {{
                          $options.filters.currency(UzexPrice.min, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col>
                <b-card
                  class="mb-0"
                  style="border: 2px solid #94BDE7;border-radius: 10px"
                >
                  <p class="text-center mt-0 pt-0">{{ $t("EduXaridPrice") }}</p>
                  <b-row>
                    <b-col>{{ $t("max") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:red">{{
                        $options.filters.currency(EduXaridPrice.max, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("avg") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:orange">
                        {{
                          $options.filters.currency(EduXaridPrice.avg, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("min") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:green">{{
                        $options.filters.currency(EduXaridPrice.min, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  style="border: 2px solid #CBE5FC;background-color:#DCEDFC"
                >
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <p
                            class="text-center"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("quantityByPeriod")
                            }}{{ tabrow.unitofmeasurename }}
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("priceByPeriod") }}({{ $t("som") }})
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("sumByPeriod") }}({{ $t("som") }})
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month1") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month1 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month1 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month1')"
                                v-model="tabrow.PriceByPeriod.Month1"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month1 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month1')"
                                v-model="tabrow.PriceByPeriod.Month1"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month1,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month2") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month2 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month2 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month2')"
                                v-model="tabrow.PriceByPeriod.Month2"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month2 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month2')"
                                v-model="tabrow.PriceByPeriod.Month2"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month2,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month3") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month3 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month3 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month3')"
                                v-model="tabrow.PriceByPeriod.Month3"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month3 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month3')"
                                v-model="tabrow.PriceByPeriod.Month3"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month3,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month4") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month4 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month4 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month4')"
                                v-model="tabrow.PriceByPeriod.Month4"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month4 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month4')"
                                v-model="tabrow.PriceByPeriod.Month4"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month4,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month5") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month5 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month5 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month5')"
                                v-model="tabrow.PriceByPeriod.Month5"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month5 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month5')"
                                v-model="tabrow.PriceByPeriod.Month5"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month5,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month6") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month6 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month6 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month')"
                                v-model="tabrow.PriceByPeriod.Month6"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month6 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month')"
                                v-model="tabrow.PriceByPeriod.Month6"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month6,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <b-row>
                        <b-col>
                          <p
                            class="text-center"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("quantityByPeriod")
                            }}{{ tabrow.unitofmeasurename }}
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("priceByPeriod") }}({{ $t("som") }})
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("sumByPeriod") }}({{ $t("som") }})
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month7") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month7 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month7 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month7')"
                                v-model="tabrow.PriceByPeriod.Month7"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month7 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month7')"
                                v-model="tabrow.PriceByPeriod.Month7"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month7,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month8") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month8 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month8 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month8')"
                                v-model="tabrow.PriceByPeriod.Month8"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month8 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month8')"
                                v-model="tabrow.PriceByPeriod.Month8"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month8,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month9") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month9 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month9 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month9')"
                                v-model="tabrow.PriceByPeriod.Month9"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month9 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month9')"
                                v-model="tabrow.PriceByPeriod.Month9"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month9,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month10") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month10 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month10 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month10')"
                                v-model="tabrow.PriceByPeriod.Month10"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month10 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month10')"
                                v-model="tabrow.PriceByPeriod.Month10"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month10,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month11") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month11 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month11 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month11')"
                                v-model="tabrow.PriceByPeriod.Month11"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month11 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month11')"
                                v-model="tabrow.PriceByPeriod.Month11"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month11,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month12") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month12 }}</b>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month12 == 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month12')"
                                v-model="tabrow.PriceByPeriod.Month12"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col v-if="tabrow.QuantityByPeriod.Month12 != 0">
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month12')"
                                v-model="tabrow.PriceByPeriod.Month12"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month12,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="form-group form-row ">
                        <label
                          style="font-size:18px"
                          class="col-form-label col-sm-5"
                          for
                          >{{ $t("Total") }} :</label
                        >
                        <div class="col-sm-7 mt-2">
                          <p style="font-size:18px">
                            <b>{{
                              $options.filters.currency(
                                tabrow.QuantityByPeriod.Yearly,
                                { symbol: " ", fractionCount: 2 }
                              )
                            }}</b>
                          </p>
                        </div>
                      </div>
                    </b-col>

                    <b-col>
                      <div class="form-group form-row ">
                        <label
                          style="font-size:18px;"
                          class="col-form-label col-sm-5"
                          for
                          >{{ $t("yearly") }} :</label
                        >
                        <div class="col-sm-7 mt-2">
                          <p style="font-size:18px">
                            <b>{{
                              $options.filters.currency(
                                tabrow.SumByPeriod.Yearly,
                                { symbol: " ", fractionCount: 2 }
                              )
                            }}</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("purchasebase")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      :options="GetAllPurchaseBaseList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.purchasebaseid"
                      @input="ChangePurchasebase"
                    ></v-select>
                  </div>
                </div>

                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("itemofexpense")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      :options="ItemOfExpenseList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.itemofexpenseid"
                      @input="ChangeItemOfExpense"
                    ></v-select>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("organizationaccount")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      :options="OrganizationAccountList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.organizationaccountid"
                      @input="ChangeOrganization"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <!-- <b-button
              v-if="RegulationForNextYearDetail.CanEstimat === false"
              @click="PurReqTableModal = false"
              variant="outline-danger"
              style="margin-right:5px"
            >
              {{ $t("back") }}
            </b-button> -->
            <b-button
              v-if="
                $can('PurchaseRequisitionForNextYearEstimate', 'permissions') &&
                  RegulationForNextYearDetail.CanEstimat === true
              "
              @click="PurReqTableModal = false"
              variant="outline-danger"
              style="margin-right:5px"
            >
              {{ $t("back") }}
            </b-button>
            <b-button
              v-if="
                $can('PurchaseRequisitionForNextYearEstimate', 'permissions') &&
                  RegulationForNextYearDetail.CanEstimat === true
              "
              @click="UpdateTable"
              variant="outline-success"
            >
              <b-spinner v-if="PurReqTableModalLoading" small></b-spinner>
              {{ $t("save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="PurReqTableModalView"
        no-close-on-backdrop
        hide-footer
        size="xl"
        :title="$t('Tables')"
      >
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-12" for
                    >{{ $t("purchasepurpose") }} :
                    <b>{{ tabrow.purchasepurpose }}</b></label
                  >
                  <!-- <div class="col-sm-12 mt-2">
                    <b>{{ tabrow.purchasepurpose }}</b>
                  </div> -->
                </div>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("productcategory") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.productenktcode }}</b>
                  </div>
                </div>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("product") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.productname }}</b>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-12" for
                    >{{ $t("productinfo") }} :
                    <b>{{ tabrow.productinfo }}</b></label
                  >
                  <!-- <div class="col-sm-12 mt-2">
                    <b>{{ tabrow.productinfo }}</b>
                  </div> -->
                </div>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("unitofmeasure") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b>{{ tabrow.unitofmeasurename }}</b>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-0 pb-2">
              <b-col>
                <b-card
                  class="mb-0 "
                  style="border: 2px solid #94BDE7;border-radius: 10px"
                >
                  <p class="text-center mt-0 pt-0">{{ $t("UzexPrice") }}</p>
                  <b-row>
                    <b-col>{{ $t("max") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:red">{{
                        $options.filters.currency(UzexPrice.max, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("avg") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:orange">
                        {{
                          $options.filters.currency(UzexPrice.avg, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>{{ $t("min") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:green">
                        {{
                          $options.filters.currency(UzexPrice.min, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col>
                <b-card
                  class="mb-0"
                  style="border: 2px solid #94BDE7;border-radius: 10px"
                >
                  <p class="text-center mt-0 pt-0">{{ $t("EduXaridPrice") }}</p>
                  <b-row>
                    <b-col>{{ $t("max") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:red">{{
                        $options.filters.currency(EduXaridPrice.max, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("avg") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:orange">
                        {{
                          $options.filters.currency(EduXaridPrice.avg, {
                            symbol: "  ",
                            fractionCount: 0,
                          })
                        }}</span
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>{{ $t("min") }}:</b-col>
                    <b-col class="text-right">
                      <span style="color:green">{{
                        $options.filters.currency(EduXaridPrice.min, {
                          symbol: "  ",
                          fractionCount: 0,
                        })
                      }}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  style="border: 2px solid #CBE5FC;background-color:#DCEDFC"
                >
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <p
                            class="text-center"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("quantityByPeriod") }} (
                            {{ tabrow.unitofmeasurename }})
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("priceByPeriod") }} ({{ $t("som") }})
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("sumByPeriod") }} ({{ $t("som") }})
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month1") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month1 }} </b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month1')"
                                v-model="tabrow.PriceByPeriod.Month1"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month1,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month2") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month2 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month2')"
                                v-model="tabrow.PriceByPeriod.Month2"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month2,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month3") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month3 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month3')"
                                v-model="tabrow.PriceByPeriod.Month3"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month3,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month4") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month4 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month4')"
                                v-model="tabrow.PriceByPeriod.Month4"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month4,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month5") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month5 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month5')"
                                v-model="tabrow.PriceByPeriod.Month5"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month5,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month6") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month6 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month')"
                                v-model="tabrow.PriceByPeriod.Month6"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month6,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <b-row>
                        <b-col>
                          <p
                            class="text-center"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("quantityByPeriod") }}
                            {{ tabrow.unitofmeasurename }}
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("priceByPeriod") }} ({{ $t("som") }})
                          </p>
                        </b-col>
                        <b-col>
                          <p
                            class="text-left"
                            style="font-size:14px;font-weight:bold"
                          >
                            {{ $t("sumByPeriod") }} ({{ $t("som") }})
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month7") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month7 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month7')"
                                v-model="tabrow.PriceByPeriod.Month7"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month7,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month8") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month8 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month8')"
                                v-model="tabrow.PriceByPeriod.Month8"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month8,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month9") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month9 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month9')"
                                v-model="tabrow.PriceByPeriod.Month9"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month9,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month10") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month10 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month10')"
                                v-model="tabrow.PriceByPeriod.Month10"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month10,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month11") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month11 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month11')"
                                v-model="tabrow.PriceByPeriod.Month11"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month11,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group form-row ">
                            <label class="col-form-label col-sm-6" for
                              >{{ $t("month12") }} :</label
                            >
                            <div class="col-sm-6 mt-2">
                              <b>{{ tabrow.QuantityByPeriod.Month12 }}</b>
                            </div>
                          </div>
                        </b-col>

                        <b-col>
                          <div class="form-group form-row ">
                            <div class="col-sm-11 mt-2">
                              <custom-number-input
                                disabled
                                @input="Calculate"
                                class="ml-n3"
                                :placeholder="$t('month12')"
                                v-model="tabrow.PriceByPeriod.Month12"
                              ></custom-number-input>
                            </div>
                          </div>
                        </b-col>
                        <b-col class="text-right">
                          <div class="form-group form-row ">
                            <div class="col-sm-7 mt-2">
                              <b>{{
                                $options.filters.currency(
                                  tabrow.SumByPeriod.Month12,
                                  { symbol: " ", fractionCount: 2 }
                                )
                              }}</b>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="form-group form-row ">
                        <label
                          style="font-size:18px"
                          class="col-form-label col-sm-5"
                          for
                          >{{ $t("TotalProduct") }} :</label
                        >
                        <div class="col-sm-7 mt-2">
                          <p style="font-size:18px">
                            <b>{{
                              $options.filters.currency(
                                tabrow.QuantityByPeriod.Yearly,
                                { symbol: " ", fractionCount: 2 }
                              )
                            }}</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="form-group form-row ">
                        <label
                          style="font-size:18px;"
                          class="col-form-label col-sm-5"
                          for
                          >{{ $t("yearlyProduct") }} :</label
                        >
                        <div class="col-sm-7 mt-2">
                          <p style="font-size:18px">
                            <b>{{
                              $options.filters.currency(
                                tabrow.SumByPeriod.Yearly,
                                { symbol: " ", fractionCount: 2 }
                              )
                            }}</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("purchasebase") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b class="m-0 p-0"> {{ tabrow.purchasebasename }}</b>
                  </div>
                </div>

                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("organizationaccount") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b class="m-0 p-0"> {{ tabrow.organizationaccountname }}</b>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for
                    >{{ $t("itemofexpense") }} :</label
                  >
                  <div class="col-sm-7 mt-2">
                    <b class="m-0 p-0"> {{ tabrow.itemofexpensename }}</b>
                  </div>
                </div>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col>
                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("purchasebase")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      disabled
                      :options="GetAllPurchaseBaseList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.purchasebaseid"
                      @input="ChangePurchasebase"
                    ></v-select>
                  </div>
                </div>
                <div class="form-group form-row m-2">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("itemofexpense")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      disabled
                      :options="ItemOfExpenseList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.itemofexpenseid"
                      @input="ChangeItemOfExpense"
                    ></v-select>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group form-row ">
                  <label class="col-form-label col-sm-5" for>{{
                    $t("organizationaccount")
                  }}</label>
                  <div class="col-sm-7">
                    <v-select
                      disabled
                      :options="OrganizationAccountList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="tabrow.organizationaccountid"
                      @input="ChangeOrganization"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row> -->
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              @click="PurReqTableModalView = false"
              variant="outline-danger"
              style="margin-right:5px"
            >
              {{ $t("back") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="ApproveModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Approve')"
      >
        <h4>{{ $t("WantApprove") }}</h4>

        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="ApproveModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="Approve" variant="outline-success"
              ><b-spinner v-if="ApproveLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="CancelApprovalModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('CancelApproval')"
      >
        <h4>{{ $t("WantCancelApproval") }}</h4>

        <!-- <b-form-textarea v-model="DataReject.rejectReaseon"></b-form-textarea> -->
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="CancelApprovalModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="CancelApproval" variant="outline-success"
              ><b-spinner v-if="CancelApprovalLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="RejectModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Reject')"
      >
        <h4>{{ $t("WantReject") }}</h4>
        <b-row class="mb-2">
          <b-col>
            <label for=""> {{ $t("rejectReason") }} </label>
            <b-form-input
              :placeholder="$t('rejectReason')"
              v-model="DataReject.rejectReason"
            ></b-form-input>
          </b-col>
        </b-row>
        <!-- <b-form-textarea v-model="DataReject.rejectReaseon"></b-form-textarea> -->
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="RejectModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="Reject" variant="outline-success"
              ><b-spinner v-if="RejectLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="EstimateModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Estimate')"
      >
        <h4>{{ $t("WantEstimate") }}</h4>
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="EstimateModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="Estimate" variant="outline-success"
              ><b-spinner v-if="EstimateLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="AcceptModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Accept')"
      >
        <h4>{{ $t("WantAccept") }}</h4>
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              @click="AcceptModal = false"
              variant="outline-danger"
              style="margin-right:5px"
            >
              {{ $t("no") }}</b-button
            >
            <b-button @click="Accept" variant="outline-success"
              ><b-spinner v-if="AcceptLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="SendModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Send')"
      >
        <h4>{{ $t("WantSend") }}</h4>
        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end ">
            <b-button
              variant="outline-danger"
              @click="SendModal = false"
              style="margin-right:5px"
            >
              {{ $t("no") }}
            </b-button>
            <b-button @click="Send" variant="outline-success">
              <b-spinner v-if="SendLoading" small></b-spinner>
              {{ $t("yes") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import CustomNumberInput from "../../../components/CustomNumberInput.vue";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import PurchaseRequisitionForNextYearService from "@/services/document/purchaserequistionfornextyear.service";
import PurchaseRequisitionService from "@/services/document/purchaserequisition.service";
import TimeLine from "../../../router/views/utility/timeline.vue";
import HelperService from "@/services/others/helper.service";
import ItemOfExpenseService from "@/services/info/itemofexpense.service";
import OrganizationAccountService from "@/services/others/organizationaccount.service";
import Multiselect from "vue-multiselect";
import RangeSliderComponent from "../../../components/RangeSliderComponent.vue";
export default {
  components: {
    Multiselect,
    Layout,
    PageHeader,
    TimeLine,
    CustomNumberInput,
    RangeSliderComponent,
  },
  data() {
    return {
      title: this.$t("PurchaseRequisition"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurchaseRequisition"),
          active: true,
        },
      ],
      options: ["Бюджет", "Не бюджет"],
      fields: [
        {
          key: "number",
          label: this.$t("№"),
          thClass: "text-left",
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "productenktcode",
          label: this.$t("productcategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "productname",
          label: this.$t("product"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        // {
        //   key: "productinfo",
        //   label: this.$t("productinfo"),
        //   thClass: "text-center",
        //   sortable: true,
        // },
        // {
        //   key: "unitofmeasurename",
        //   label: this.$t("unitofmeasure"),
        //   thClass: "text-center",
        //   tdClass: "text-left",
        //   sortable: true,
        //   thStyle: { width: "5% !important" },
        // },
        {
          key: "Quater1",
          label: this.$t("Quarter1"),
          tdClass: "text-right",
          thStyle: { width: "8% !important" },
        },
        {
          key: "Quater2",
          label: this.$t("Quarter2"),
          tdClass: "text-right",
          thStyle: { width: "7% !important" },
        },
        {
          key: "Quater3",
          label: this.$t("Quarter3"),
          tdClass: "text-right",
          thStyle: { width: "8% !important" },
        },
        {
          key: "Quater4",
          label: this.$t("Quarter4"),
          tdClass: "text-right",
          thStyle: { width: "7% !important" },
        },
        {
          key: "Yearly",
          label: this.$t("yearly"),
          tdClass: "text-right",
          thStyle: { width: "5% !important" },
        },
        {
          key: "YearlySum",
          label: this.$t("yearlysum"),
          tdClass: "text-right",
          thStyle: { width: "10% !important" },
        },
        // {
        //   key: "purchasequantity",
        //   label: this.$t("purchasequantity"),
        //   thClass: "text-center",
        //   sortable: true,
        // },
        {
          key: "purchasebasename",
          label: this.$t("purchasebase"),
          tdClass: "text-left",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "organizationaccountname",
          label: this.$t("organizationaccount"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "itemofexpensename",
          label: this.$t("itemofexpense"),
          tdClass: "text-left",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],
      UpdatePurReqTable: {},
      PurReqTableModalLoading: false,
      PurReqTableModal: false,
      CancelApprovalModal: false,
      PurReqTableModalView: false,
      CancelApprovalLoading: false,
      ApproveModal: false,
      ApproveLoading: false,
      RejectLoading: false,
      RejectModal: false,
      EstimateLoading: false,
      EstimateModal: false,
      AcceptLoading: false,
      AcceptModal: false,
      SideBar: false,
      items: [],
      PurchaseRequisition: {},
      PurchaseRequisitionTable: [],
      isLoading: false,
      RegulationDetailHistory: [],
      SendModal: false,
      SendLoading: false,
      RegulationForNextYearDetail: {},
      RegulationMonthsDetailTables: [],
      OrganizationAccountList: [],
      ItemOfExpenseList: [],
      editedIndex1: -1,
      editedIndex2: -1,
      tabrow: {
        id: 0,
        ownerid: 0,
        purchasepurpose: "",
        deliverytime: "",
        productcategoryid: 0,
        productenktcode: "",
        productid: 0,
        productname: "",
        productinfo: "",
        unitofmeasureid: 0,
        unitofmeasurename: "",
        purchasebase: "",
        organizationaccountid: 0,
        organizationaccountname: "",
        itemofexpenseid: 0,
        itemofexpensename: "",
        QuantityByPeriod: {
          Month1: 0,
          Month2: 0,
          Month3: 0,
          Month4: 0,
          Month5: 0,
          Month6: 0,
          Month7: 0,
          Month8: 0,
          Month9: 0,
          Month10: 0,
          Month11: 0,
          Month12: 0,
          Quarter1: 0,
          Quarter2: 0,
          Quarter3: 0,
          Quarter4: 0,
          Yearly: 0,
        },
        PriceByPeriod: {
          Month1: 0,
          Month2: 0,
          Month3: 0,
          Month4: 0,
          Month5: 0,
          Month6: 0,
          Month7: 0,
          Month8: 0,
          Month9: 0,
          Month10: 0,
          Month11: 0,
          Month12: 0,
          Yearly: 0,
        },
        SumByPeriod: {
          Month1: 0,
          Month2: 0,
          Month3: 0,
          Month4: 0,
          Month5: 0,
          Month6: 0,
          Month7: 0,
          Month8: 0,
          Month9: 0,
          Month10: 0,
          Month11: 0,
          Month12: 0,
          Yearly: 0,
        },

        Status: 1,
      },
      EduXaridPrice: [],
      GetAllPurchaseBaseList: [],
      UzexPrice: [],
      total: { totalsum: 0 },
      DataReject: {
        id: 0,
        rejectReason: "",
      },
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;

    // OrganizationAccountService.GetAll(this.lang).then((res) => {
    //   this.OrganizationAccountList = res.data;
    // });

    this.Refresh();
  },
  directives: {},
  methods: {
    ChangePurchasebase() {
      this.tabrow.organizationaccountid = 0;
      if (!!this.tabrow.purchasebaseid) {
        OrganizationAccountService.GetAll(
          this.tabrow.purchasebaseid,
          this.RegulationForNextYearDetail.organizationid
        ).then((res) => {
          this.OrganizationAccountList = res.data;
        });
        this.tabrow.purchasebasename = this.GetAllPurchaseBaseList.filter(
          (item) => this.tabrow.purchasebaseid === item.id
        )[0].name;
      }
    },
    calculate() {
      this.total = {
        totalsum: 0,
      };

      for (var i = 0; i < this.RegulationMonthsDetailTables.length; i++) {
        this.total.totalsum +=
          1 * this.RegulationMonthsDetailTables[i].SumByPeriod.Yearly;
      }
    },
    ChangeItemOfExpense() {
      // console.log(this.tabrow.itemofexpensename);

      this.tabrow.itemofexpensename = this.ItemOfExpenseList.filter(
        (item) => this.tabrow.itemofexpenseid === item.id
      )[0].name;
    },
    // numberFor() {
    //   this.number = 0;
    //   for (var i = 0; i < 100000; i++) {
    //     this.number = i + 1;
    //   }
    // },

    ChangeOrganization() {
      this.tabrow.organizationaccountname = this.OrganizationAccountList.filter(
        (item) => this.tabrow.organizationaccountid === item.id
      )[0].name;
    },
    Refresh() {
      PurchaseRequisitionForNextYearService.GetDetail(
        this.$route.params.id
      ).then((res) => {
        this.RegulationForNextYearDetail =
          res.data.ParentContribRequestForView.PurchaseRequisitionForNextYear.PurchaseRequisition;
        this.RegulationDetailHistory =
          res.data.ParentContribRequestForView.History;
        this.RegulationMonthsDetailTables =
          res.data.ParentContribRequestForView.PurchaseRequisitionForNextYear.MonthTables;
        this.calculate();
      });
    },
    Calculate() {
      this.tabrow.SumByPeriod.Month1 =
        parseFloat(this.tabrow.QuantityByPeriod.Month1) *
        parseFloat(this.tabrow.PriceByPeriod.Month1);
      this.tabrow.SumByPeriod.Month2 =
        parseFloat(this.tabrow.QuantityByPeriod.Month2) *
        parseFloat(this.tabrow.PriceByPeriod.Month2);
      this.tabrow.SumByPeriod.Month3 =
        parseFloat(this.tabrow.QuantityByPeriod.Month3) *
        parseFloat(this.tabrow.PriceByPeriod.Month3);
      this.tabrow.SumByPeriod.Month4 =
        parseFloat(this.tabrow.QuantityByPeriod.Month4) *
        parseFloat(this.tabrow.PriceByPeriod.Month4);
      this.tabrow.SumByPeriod.Month5 =
        parseFloat(this.tabrow.QuantityByPeriod.Month5) *
        parseFloat(this.tabrow.PriceByPeriod.Month5);
      this.tabrow.SumByPeriod.Month6 =
        parseFloat(this.tabrow.QuantityByPeriod.Month6) *
        parseFloat(this.tabrow.PriceByPeriod.Month6);
      this.tabrow.SumByPeriod.Month7 =
        parseFloat(this.tabrow.QuantityByPeriod.Month7) *
        parseFloat(this.tabrow.PriceByPeriod.Month7);
      this.tabrow.SumByPeriod.Month8 =
        parseFloat(this.tabrow.QuantityByPeriod.Month8) *
        parseFloat(this.tabrow.PriceByPeriod.Month8);
      this.tabrow.SumByPeriod.Month9 =
        parseFloat(this.tabrow.QuantityByPeriod.Month9) *
        parseFloat(this.tabrow.PriceByPeriod.Month9);
      this.tabrow.SumByPeriod.Month10 =
        parseFloat(this.tabrow.QuantityByPeriod.Month10) *
        parseFloat(this.tabrow.PriceByPeriod.Month10);
      this.tabrow.SumByPeriod.Month11 =
        parseFloat(this.tabrow.QuantityByPeriod.Month11) *
        parseFloat(this.tabrow.PriceByPeriod.Month11);
      this.tabrow.SumByPeriod.Month12 =
        parseFloat(this.tabrow.QuantityByPeriod.Month12) *
        parseFloat(this.tabrow.PriceByPeriod.Month12);
      this.tabrow.SumByPeriod.Yearly =
        parseFloat(this.tabrow.SumByPeriod.Month1) +
        parseFloat(this.tabrow.SumByPeriod.Month2) +
        parseFloat(this.tabrow.SumByPeriod.Month3) +
        parseFloat(this.tabrow.SumByPeriod.Month4) +
        parseFloat(this.tabrow.SumByPeriod.Month5) +
        parseFloat(this.tabrow.SumByPeriod.Month6) +
        parseFloat(this.tabrow.SumByPeriod.Month7) +
        parseFloat(this.tabrow.SumByPeriod.Month8) +
        parseFloat(this.tabrow.SumByPeriod.Month9) +
        parseFloat(this.tabrow.SumByPeriod.Month10) +
        parseFloat(this.tabrow.SumByPeriod.Month11) +
        parseFloat(this.tabrow.SumByPeriod.Month12);
    },

    OpenPurReqTableModal(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex1 = this.RegulationMonthsDetailTables.indexOf(item);
      this.tabrow = Object.assign({}, item);
      // PurchaseRequisitionService.GetPurReqTable(this.$route.params.id).then(
      //   (res) => {
      //     this.PurReqTable = res.data;
      //   }
      // );

      this.PurReqTableModal = true;
      // OrganizationAccountService.GetAll(this.tabrow.purchasebaseid, this.RegulationForNextYearDetail.organizationid).then(
      //   (res) => {
      //     this.OrganizationAccountList = res.data;
      //   }
      // );
      OrganizationAccountService.GetAll(
        this.tabrow.purchasebaseid,
        this.RegulationForNextYearDetail.organizationid
      ).then((res) => {
        this.OrganizationAccountList = res.data;
      });
      ItemOfExpenseService.GetAll(this.lang).then((res) => {
        this.ItemOfExpenseList = res.data;
      });
      HelperService.GetAllPurchaseBase().then((res) => {
        this.GetAllPurchaseBaseList = res.data;
      });
      this.tabrow.purchasebasename = this.GetAllPurchaseBaseList.filter(
        (item) => this.tabrow.purchasebaseid === item.id
      )[0].name;

      PurchaseRequisitionService.GetStatisticsOfPriceInProduct(
        this.tabrow.productid,
        this.RegulationForNextYearDetail.docdate
      ).then((res) => {
        this.UzexPrice = res.data.result.uzexprice;
        this.EduXaridPrice = res.data.result.eduxaridprice;
      });
    },
    OpenPurReqTableModalView(item) {
      this.editedIndex2 = this.RegulationMonthsDetailTables.indexOf(item);
      this.tabrow = Object.assign({}, item);
      this.PurReqTableModalView = true;
      PurchaseRequisitionService.GetStatisticsOfPriceInProduct(
        this.tabrow.productid,
        this.RegulationForNextYearDetail.docdate
      ).then((res) => {
        this.UzexPrice = res.data.result.uzexprice;
        this.EduXaridPrice = res.data.result.eduxaridprice;
      });
    },
    // AddRow() {
    //   if (this.editedIndex1 > -1) {
    //     Object.assign(
    //       this.RegulationDetailTables[this.editedIndex1],
    //       this.tabrow
    //     );
    //   } else {
    //     this.RegulationDetailTables.push(this.tabrow);
    //   }
    //   this.PurReqTableModal = false;
    // },
    OpenApproveModal() {
      this.ApproveModal = true;
    },
    OpenCancelApprovalModal() {
      this.CancelApprovalModal = true;
    },
    OpenRejectModal() {
      this.RejectModal = true;
      this.DataReject = {
        id: this.$route.params.id,
        rejectReason: "",
      };
    },
    OpenEstimateModal() {
      this.EstimateModal = true;
    },
    OpenAcceptModal() {
      this.AcceptModal = true;
    },
    getColor(item) {
      if (item.statusname === "Создан") {
        return "primary";
      } else if (item.statusname === "Изменен") {
        return "info";
      } else if (item.statusname === "Отклонен") {
        return "danger";
      } else if (item.statusname === "Отменено") {
        return "danger";
      } else if (item.statusname === "Утвержден") {
        return "success";
      } else if (item.statusname === "Одобрен") {
        return "success";
      } else if (item.statusname === "Оценен") {
        return "secondary";
      } else if (item.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },
    getColorStatus(RegulationForNextYearDetail) {
      if (RegulationForNextYearDetail.statusname === "Создан") {
        return "primary";
      } else if (RegulationForNextYearDetail.statusname === "Изменен") {
        return "info";
      } else if (RegulationForNextYearDetail.statusname === "Отклонен") {
        return "danger";
      } else if (RegulationForNextYearDetail.statusname === "Отменено") {
        return "danger";
      } else if (RegulationForNextYearDetail.statusname === "Утвержден") {
        return "success";
      } else if (RegulationForNextYearDetail.statusname === "Оценен") {
        return "secondary";
      } else if (RegulationForNextYearDetail.statusname === "Одобрен") {
        return "success";
      } else if (RegulationForNextYearDetail.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },
    OpenSendModal() {
      this.SendModal = true;
    },
    OpenSideBar() {
      this.SideBar = true;
    },
    Reject() {
      this.RejectLoading = true;
      PurchaseRequisitionForNextYearService.Reject(this.DataReject)
        .then((res) => {
          this.RejectLoading = true;
          this.$notification(this.$t("RejectSuccess"), "success");
          this.RejectModal = false;
          setTimeout(() => {
            this.$router.push({ name: "PurchaseRequisitionStatusForNextYear" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.RejectLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    Accept() {
      this.AcceptLoading = true;
      PurchaseRequisitionForNextYearService.Accept(this.$route.params.id)
        .then((res) => {
          this.AcceptLoading = false;
          this.$notification(this.$t("AcceptSuccess"), "success");
          this.AcceptModal = false;
          setTimeout(() => {
            this.$router.push({ name: "PurchaseRequisitionStatusForNextYear" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.AcceptLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    Approve() {
      this.ApproveLoading = true;
      PurchaseRequisitionForNextYearService.Approve(this.$route.params.id)
        .then((res) => {
          this.ApproveLoading = false;
          this.$notification(this.$t("ApproveSuccess"), "success");
          this.ApproveModal = false;
          setTimeout(() => {
            this.$router.push({ name: "PurchaseRequisitionStatusForNextYear" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.ApproveLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    CancelApproval() {
      this.CancelApprovalLoading = true;
      PurchaseRequisitionForNextYearService.CancelApproval(
        this.$route.params.id
      )
        .then((res) => {
          this.CancelApprovalLoading = false;
          this.$notification(this.$t("CancelApprovalSuccess"), "success");
          this.CancelApprovalModal = false;
          setTimeout(() => {
            this.$router.push({ name: "PurchaseRequisitionStatusForNextYear" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.CancelApprovalLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    Estimate() {
      this.EstimateLoading = true;
      PurchaseRequisitionForNextYearService.Estimate(this.$route.params.id)
        .then((res) => {
          this.EstimateLoading = false;
          this.$notification(this.$t("EstimateSuccess"), "success");
          this.EstimateModal = false;
          setTimeout(() => {
            this.$router.push({ name: "PurchaseRequisitionStatusForNextYear" });
          }, 500);
        })
        .catch((error) => {
          this.EstimateLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    Send() {
      this.SendLoading = true;
      PurchaseRequisitionForNextYearService.Send(this.$route.params.id)
        .then((res) => {
          this.SendLoading = false;
          //   this.Refresh();
          this.$notification(this.$t("SendSuccess"), "success");
          this.SendModal = false;
          // setTimeout(() => {
          //   this.$router.push({ name: "PurchaseRequisitionStatus" });
          // }, 500);
          this.$router.go(-1);
        })
        .catch((error) => {
          this.SendLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    checkTable() {
      // if (
      //   this.tabrow.purchaseprice === 0 ||
      //   this.tabrow.purchaseprice === null ||
      //   this.tabrow.purchaseprice === undefined ||
      //   this.tabrow.purchaseprice === ""
      // ) {
      //   this.$notification(this.$t("purchasepriceNotSelected"), "danger");
      //   return false;
      // }
      if (
        this.tabrow.purchasebaseid === 0 ||
        this.tabrow.purchasebaseid === null ||
        this.tabrow.purchasebaseid === undefined ||
        this.tabrow.purchasebaseid === ""
      ) {
        this.$notification(this.$t("purchasebaseNotSelected"), "danger");
        return false;
      }
      if (
        this.tabrow.itemofexpenseid === 0 ||
        this.tabrow.itemofexpenseid === null ||
        this.tabrow.itemofexpenseid === undefined ||
        this.tabrow.itemofexpenseid === ""
      ) {
        this.$notification(this.$t("itemofexpenseNotSelected"), "danger");
        return false;
      }
      if (
        this.tabrow.organizationaccountid === 0 ||
        this.tabrow.organizationaccountid === null ||
        this.tabrow.organizationaccountid === undefined ||
        this.tabrow.organizationaccountid === ""
      ) {
        this.$notification(this.$t("organizationaccountNotSelected"), "danger");
        return false;
      }

      return true;
    },
    UpdateTable() {
      if (!this.checkTable()) {
        return false;
      }
      PurchaseRequisitionForNextYearService.UpdatePurReqTable(this.tabrow)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.PurReqTableModal = false;
          this.Refresh();
        })
        .catch((error) => {
          this.$notification(this.$t(error.response.data.error), "danger");
        });
    },
  },
};
</script>

<style>
.tab {
  margin-left: 15px;
}
.CardMain {
  border-radius: 10px;
  border-top: #318ce7 solid 5px;
}
.TableCard {
  border-radius: 10px;
  border-top: #20b2aa solid 5px;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
</style>
